import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {InvoiceUpload} from '@invoice-upload/models/invoice-upload';
import {FileUpload} from 'primeng/fileupload';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'mojo-invoice-upload',
  templateUrl: './invoice-upload.component.html',
})
export class InvoiceUploadComponent implements OnInit {

  @Input() files: InvoiceUpload[] = [];
  @Input() invalidFileTypeMessage = 'Invalid file type, please upload files of the type pdf only';
  @Input() invalidFileTypeMessageDetail = '';

  @Output() delete = new EventEmitter<InvoiceUpload>();
  @Output() upload = new EventEmitter<File[]>();
  @Output() itemClick = new EventEmitter<InvoiceUpload>();
  @ViewChild('fileUploader', {static: true}) fileUploader: FileUpload;

  displayFileUploadWigetSubject = new BehaviorSubject<boolean>(false);
  value = new Date();

  get isIE11() {
    return window.navigator.userAgent.toLowerCase().indexOf('trident') > -1;
  }


  constructor(private readonly ref: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  forceIERefresh() {
    if (this.isIE11) {
      this.ref.detectChanges();
    }
  }

  handleSelect(e) {
    console.error('select', e);
  }


  handleError(e) {
    console.error('file upload error ', e);
  }

  ngOnChanges() {
    this.forceIERefresh();
  }

  clearFiles() {
    this.fileUploader.clear();
    if (this.fileUploader.isIE11()) {
      this.fileUploader.clearIEInput();
    }
  }


  fileUploadEvent(evt) {
    this.upload.emit(evt.files);
    this.clearFiles();
  }

  onItemClick(file: InvoiceUpload) {
    this.itemClick.emit(file);
  }

  deleteFile(file: InvoiceUpload) {
    this.delete.emit(file);
    this.clearFiles();
  }

  hasFiles(): boolean {
    return this.files && this.files.length > 0;
  }

  getHeader(): string {
    if (this.hasFiles()) {
      return 'Click on an invoice below to provide details and send it to us';
    } else {
      return 'Drag and drop your PDF invoices below';
    }
  }

  onSelectEvent(evt) {
    if (this.hasFiles) {
      this.displayFileUploadWigetSubject.next(false);
    }
  }
}
